import { Component, computed, effect, inject, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BlankValueComponent, CustomCellComponent } from '@vendasta/galaxy/table';
import { FieldValueInterface } from '@vendasta/crm';
import { CrmPipelineService, StandardIds } from '@galaxy/crm/static';
import { map } from 'rxjs/operators';
import { firstValueFrom } from 'rxjs';

@Component({
  templateUrl: './stage-column-cell.component.html',
  imports: [CommonModule, BlankValueComponent],
})
export class CrmStageColumnCellComponent extends CustomCellComponent {
  private readonly pipelineService = inject(CrmPipelineService);

  private readonly fieldValues = signal<FieldValueInterface[]>([]);
  private readonly pipelineId = computed(
    () =>
      this.fieldValues().find((fieldValue) => fieldValue?.fieldId === StandardIds.OpportunityPipelineID)?.stringValue,
  );
  private readonly stageId = computed(
    () =>
      this.fieldValues().find((fieldValue) => fieldValue?.fieldId === StandardIds.OpportunityCalculatedStageID)
        ?.stringValue,
  );
  protected readonly stageName = signal<string | null>(null);

  set value(newValues: FieldValueInterface[]) {
    this.fieldValues.set(newValues);
  }

  constructor() {
    super();
    effect(() => this.refreshStageName(this.pipelineId()));
  }

  private async refreshStageName(id?: string): Promise<void> {
    if (id) {
      const request = this.pipelineService
        .getPipeline$(id)
        .pipe(map((pipeline) => pipeline?.stages?.find((stage) => stage.id === this.stageId())?.name || null));
      const pipelineName = await firstValueFrom(request);
      this.stageName.set(pipelineName);
    } else {
      this.stageName.set(null);
    }
  }
}
